import React, {Component} from 'react';
import {InputItem, NavBar, Toast,Popover,} from 'antd-mobile';
import "./style.less";
import {connect} from "react-redux";
import {addOften} from "../../../service/memberService";
const Item = Popover.Item;
@connect(
    state => ({userInfo: state.userInfo})
)
export default class AddOftenPsg extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name:'',
            sfzVal:'',
            phone:'',
            numVisible: false,
            numSelected: '身份证',
        };
    }
    componentDidMount() {};
    inpChange= key => (value)=>{
        this.setState({[key]:value})
    };
    addPassenger=()=>{
        if (this.state.name === '') {
            Toast.info('请填写姓名');
            return
        }
        if(this.state.sfzVal === '' ){
            Toast.info('请填写证件号');
            return
        }
        if(this.state.sfzVal.length < 5 ){
            Toast.info('证件号码不能少于5位');
            return
        }
        if(this.state.phone === ''){
            Toast.info('请填写联系电话');
            return
        }
        Toast.loading('',0);
        let params = {
            token: this.props.userInfo.token,
            source:1,
            data:{
                name:this.state.name,
                phone:this.state.phone.replace(/\s/ig, ''),
                idNum:this.state.sfzVal,
                idType:this.state.numSelected == "身份证" ? "idcard":this.state.numSelected == "护照" ? "passport" : "borderCard",
            },
        };
        console.log(params)
        addOften(params).then((res) => {
            if (res.data.code === '0000') {
                if(this.props.location.state == 'special'){
                    Toast.info("添加成功",2,()=> this.props.history.goBack());
                }else{
                    Toast.info("添加成功",2,()=> window.location.reload());
                }
            } else {
                Toast.info(res.data.msg,3);
            }
        }).catch(function (error) {
            console.log(error);
        });
    };
    onSelect = (opt) => {
        console.log(opt.props);
        this.setState({
            numVisible: false,
            numSelected: opt.props.value,
        });
    };
    handleVisibleChange = (visible) => {
        this.setState({numVisible:visible,});
    };
    render(){
        return(
            <div className="addOftenPsg">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconfanhui" onClick={() => this.props.history.goBack()}/>}
                >添加乘客</NavBar>
                <div className="warp">
                    <div className="box">
                        <InputItem
                            placeholder="请输入姓名"
                            clear
                            value={this.state.name}
                            onChange={this.inpChange('name')}
                            type="text"
                        >姓名</InputItem>
                        <InputItem
                            placeholder={"请输入"+this.state.numSelected}
                            clear
                            value={this.state.sfzVal}
                            onChange={this.inpChange('sfzVal')}
                            maxLength={18}
                            ><Popover mask
                                      overlayClassName="fortest"
                                      visible={this.state.numVisible}
                                      overlay={[
                                          (<Item key="idcard" value="身份证"  >身份证</Item>),
                                          (<Item key="passport" value="护照" >护照</Item>),
                                          (<Item key="borderCard" value="边民证" >边民证</Item>),
                                      ]}

                                      onVisibleChange={this.handleVisibleChange}
                                      onSelect={this.onSelect}
                                >
                                <div>{this.state.numSelected}<i className="icon iconfont iconxiala"/></div>
                            </Popover>
                        </InputItem>
                        <InputItem
                            placeholder="请输入联系电话"
                            clear
                            value={this.state.phone}
                            onChange={this.inpChange('phone')}
                            type="phone"
                        >联系电话</InputItem>
                    </div>
                    <div className="btn">
                        <button onClick={this.addPassenger}>添加</button>
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/member/AddOftenPsg/index.js